module.exports = __webpack_public_path__ + "img/icon_empty.12619d3c.png";